import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import { mediaQuery, Spacings } from '@styles/index';
import DppCardSkeleton from './DppCardSkeleton';

const Wrapper = styled.div`
  display: grid;
  grid-column: span 24;
  grid-template-columns: repeat(4, 272px);
  grid-column-gap: ${Spacings.SPACING_4B};
  grid-row-gap: ${Spacings.SPACING_12B};
  align-items: center;
  justify-items: center;

  ${mediaQuery.uptoTablet} {
    grid-template-columns: repeat(3, 1fr);
  }

  ${mediaQuery.uptoMobile} {
    grid-template-columns: repeat(auto-fit, minmax(272px, 1fr));
  }
`;

const DppCarousel = ({ number }) => (
  <Wrapper>
    {new Array(number).fill(0).map((val, index) => (
      <DppCardSkeleton key={String(index)} />
    ))}
  </Wrapper>
);

DppCarousel.propTypes = {
  number: PropTypes.number
};

DppCarousel.defaultProps = {
  number: 3
};

export default DppCarousel;
